import { render } from "./Question.vue?vue&type=template&id=0dc1b64f&scoped=true&class=font-Prompt"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=0dc1b64f&lang=scss&scoped=true"
import "./Question.vue?vue&type=style&index=1&id=0dc1b64f&lang=scss"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc1b64f"]])

export default __exports__